import { Stack } from '@mui/material';
import dayjs from 'dayjs';
import { TooltipProps } from 'recharts';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';
import styled from 'styled-components';
import { CompareOfferLineChartData } from 'types/chart';
import { formatPriceToKorean } from 'utils/formatUtil';

interface Props {
  isVisibleDay: boolean;
  isCompareButton: boolean | undefined;
  newChartType: string | undefined;
  compareTextType: string | undefined;
}

function CompareOfferLineChartTooltip({
  active,
  payload,
  label,
  isVisibleDay,
  isCompareButton,
  newChartType,
  compareTextType,
}: TooltipProps<ValueType, NameType> & Props) {
  if (active && payload && payload.length) {
    const payloadData: CompareOfferLineChartData = payload?.[0].payload;
    const {
      date,
      sellingOfferDanjiAveragePrice,
      wantBuyingOfferDanjiAveragePrice,
    } = payloadData;
    const formattedDate = dayjs(date).format(
      `YYYY년 MM월 ${isVisibleDay ? `DD일` : ''}`,
    );
    return (
      <TooltipBox>
        <YearMonth>{formattedDate}</YearMonth>
        <TooltipText color="#333">단지표준가격</TooltipText>
        <Stack>
          <TooltipText color="#F77933">
            {compareTextType === 'complex_compare' ? '단지 1' : '우리 집'} :{' '}
            {sellingOfferDanjiAveragePrice
              ? formatPriceToKorean(sellingOfferDanjiAveragePrice)
              : '-'}{' '}
          </TooltipText>
          <TooltipText color="#4584FF">
            {compareTextType === 'complex_compare' ? '단지 2' : '갈아탈 집'} :{' '}
            {wantBuyingOfferDanjiAveragePrice
              ? formatPriceToKorean(wantBuyingOfferDanjiAveragePrice)
              : '-'}{' '}
          </TooltipText>
        </Stack>
      </TooltipBox>
    );
  }

  return null;
}

export default CompareOfferLineChartTooltip;

const TooltipBox = styled.div`
  font-size: 0.8rem;
  background: #fff;
  padding: 14px 14px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px 0px rgba(0, 30, 81, 0.12),
    0px 0px 8px 0px rgba(0, 30, 81, 0.04);
  line-height: 24px;
  display: flex;
  flex-direction: column;
`;

const TooltipText = styled.div`
  color: ${({ color }) => color};
  font-weight: 700;
`;

const YearMonth = styled.div`
  color: #333;
  font-weight: 700;
  letter-spacing: -0.24px;
`;
